import { split, ApolloLink } from '@apollo/client';
import { getMainDefinition } from '@apollo/client/utilities';
import { WebSocketLink } from './links/webSocket.js';
import cookies from 'js-cookie';
import { createUploadLink } from 'apollo-upload-client';

function isSubscription(op) {
    var definition = getMainDefinition(op.query);
    return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
}
function createHttpLink(options) {
    var httpLink = createUploadLink({
        uri: options.endpoint,
        credentials: 'include',
        fetch: options.fetch
    });
    var link;
    if (options.webSocketEndpoint) {
        var webSocketLink = new WebSocketLink({
            uri: options.webSocketEndpoint,
            options: {
                reconnect: true,
                lazy: true,
                connectionParams: function () {
                    return {
                        xsrfToken: cookies.get('XSRF-TOKEN'),
                        viewerContext: options.viewerContext ? options.viewerContext() : undefined,
                        experimentOverrides: options.experimentOverrides,
                        apollographqlClientName: options.clientAwarenessName,
                        apollographqlClientVersion: options.clientAwarenessVersion
                    };
                }
            }
        });
        var subscriptionClient_1 = webSocketLink.subscriptionClient;
        link = {
            link: split(isSubscription, webSocketLink, httpLink),
            reconnect: function () {
                subscriptionClient_1.close(false);
            }
        };
    }
    else {
        var rejectLink = new ApolloLink(function () { return null; });
        link = {
            link: split(isSubscription, rejectLink, httpLink),
            reconnect: function () { }
        };
    }
    return link;
}

export default createHttpLink;
//# sourceMappingURL=createHttpLink.js.map
